import { actionTypes } from '../constants';

export const searchChanged = (value) => ({
  type: actionTypes.roomSearchChanged,
  payload: value,
});

export const filterChanged = (value) => ({
  type: actionTypes.roomFilterChanged,
  payload: value,
});
